export default {
      id: "app_store-usage",
      viewBox: "0 0 151 50",
      url: "/" + "sprite.svg#app_store",
      toString: function () {
        return this.url;
      }
    }